export const getOrganizationNameFromHostname = () => {
    if (typeof window === "undefined") return "";

    const envHostName = process.env.NEXT_PUBLIC_TACTIC_DOMAIN || "";
    const hostname = window.location.hostname;
    
    const escapedEnvHostName = envHostName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // Match: <subdomain>.<envHostName>
    const regex = new RegExp(`^([a-z0-9]+(?:-[a-z0-9]+)*)\\.${escapedEnvHostName}$`, "i");

    const match = hostname.match(regex);
    return match ? match[1] : "";
};